<div class="overlay" *ngIf="isLoading">
  <div class="loading-spinner"></div>
</div>
